import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PrimeNG } from 'primeng/config';
import { StateService } from './services/other/state';
import { ChangeLangService } from './services/other/change-lang';
import { ToastModule } from 'primeng/toast';
import { NgClass } from '@angular/common';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ButtonModule } from 'primeng/button';
import { SwitchThemeService } from './services/other/switch-theme';
import { FirebaseService } from './services/firebase/firebase';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    ConfirmDialogModule,
    NgClass,
    ToastModule,
    ButtonModule,
  ],
  templateUrl: './app.html',
  styleUrl: './app.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App implements OnInit {
  protected readonly title = signal('aynDashboard');
  themeService = inject(SwitchThemeService);
  primeng = inject(PrimeNG);
  stateService = inject(StateService);
  firebaseService = inject(FirebaseService);
  cls = inject(ChangeLangService);

  ngOnInit(): void {
        this.firebaseService.requestPermission();
    document.documentElement.style.fontSize = `${'13'}px`;
    this.primeng.ripple.set(true);
    this.primeng.inputStyle.set('filled');
    this.setLang();
    this.setTheme();
  }
  setTheme(): void {
    this.themeService.switchTheme(
      localStorage.getItem('theme') ? localStorage.getItem('theme')! : 'light'
    );
  }
  setLang(): void {
    this.cls.changeLang(
      localStorage.getItem('langCode')
        ? localStorage.getItem('langCode')!
        : 'en'
    );
  }


  constructor() {
    // Firebase is now initialized! You can access:
    // this.firebaseService.app
    // this.firebaseService.analytics
    // console.log('Firebase initialized!', this.firebaseService.app.name);
  }
}
